import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { PROMO_PRICE_BASE_CLASSNAME } from './Constants';
import { createPromoPrice } from './PromoPrice';
createComponents(".".concat(PROMO_PRICE_BASE_CLASSNAME), createPromoPrice, NO_PATTERN_BUSINESS_LOGIC);
